import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { LandingNav } from '../components/landing/LandingNav';
import { Portals } from '../components/landing/Portals';
import { LandingFooter } from '../components/landing/Sections';
import { BODY } from '../components/landing/shared';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#080c14]"><Loader2 className="w-8 h-8 animate-spin text-cyan-400" /></div>;
  if (user) return <Navigate to="/" replace />;
  return (
    <div className="min-h-screen text-slate-100 flex flex-col" style={{ background: '#080c14', fontFamily: BODY }} data-testid="login-page">
      <LandingNav />
      <div className="pt-20 flex-1 relative overflow-hidden">
        <div className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[500px] rounded-full" style={{ background: 'radial-gradient(closest-side, rgba(6,182,212,0.22), transparent)' }} />
        <Portals standalone />
      </div>
      <LandingFooter />
    </div>
  );
}
